export const STORAGE_VERSION = "v0.09.0-beta";
export const SNAPSHOT_ARRAY_LENGTH = 64;

export function safeParseJson(value, fallback) {
  try {
    if (
      value === undefined ||
      value === null ||
      value === "" ||
      value === "undefined" ||
      value === "null"
    ) {
      return fallback;
    }

    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

function getBaseDeviceTab(devicePrefix, deviceNumber, model) {
  return {
    interfaces: [{
      description: "",
      port: "",
      vrf: "",
      ip: "",
      subnet: "",
      interfacedhcp: false,
      linklocal: "",
      eui64: false,
      mtu: "",
      bandwidth: "",
      delay: "",
      loadinterval: "",
      speed: "",
      duplex: "",
      clockrate: "",
      encapsulation: "",
      aclIn: "",
      aclOut: "",
      ipv6AclIn: "",
      ipv6AclOut: "",
      pbrRouteMap: "",
      servicePolicyInput: "",
      servicePolicyOutput: "",
      shutdown: false,
      subinterfaces: []
    }],
    v6interfaces: [{
      description: "",
      port: "",
      vrf: "",
      ip: "",
      subnet: "",
      interfacedhcp: false,
      linklocal: "",
      eui64: false,
      mtu: "",
      bandwidth: "",
      delay: "",
      loadinterval: "",
      speed: "",
      duplex: "",
      clockrate: "",
      encapsulation: "",
      aclIn: "",
      aclOut: "",
      ipv6AclIn: "",
      ipv6AclOut: "",
      pbrRouteMap: "",
      servicePolicyInput: "",
      servicePolicyOutput: "",
      shutdown: false,
      v6subinterfaces: []
    }],
    dynamicnatport: [],
    dynamicnat: [],
    misc: [{}, {}, {}],
    staticnat: [],
    linterfaces: [],
    basicsecurity: [{}],
    urpf: [],
    localaaa: [{ users: [] }],
    advancedaaa: [],
    namedeigrp: [],
    eigrp: [],
    bgp: [
      {
        redistributions: [],
        networks: [],
        v6networks: [],
        passive: [],
        enabled: [],
        neighbours: [],
        v6neighbours: []
      }
    ],
    hsrp: [],
    vrrp: [],
    dhcp: [{ ip: "" }],
    dhcpexclusion: [],
    dhcphelper: [],
    initial: [
      {
        hostname: `${devicePrefix}${deviceNumber}`,
        motd: "May your day be filled with Cisco",
        domain: "network.internal",
        secret: "class",
        con0pass: "cisco",
        vtypass: "cisco",
        clock: true,
        model,
        synchronuslogging: true,
        ipv6unicastrouting: false,
        passwordencryption: true,
        disabledomainlookup: true,
        enablessh: true,
        telnet: false,
        cdp: true,
        lldp: false,
        sshv2: true,
        genereatersa: true
      }
    ],
    staticroute: [{}],
    ospf: [],
    v3ospf: [],
    vrf: [],
    ntp: [{}],
    ntpservers: [],
    syslog: [{}],
    syslogservers: [],
    snmp: [{}],
    snmpcommunities: [],
    snmphosts: [],
    snmpv3groups: [],
    snmpv3users: [],
    snmpv3views: [],
    ipv4acls: [],
    ipv6acls: [],
    prefixlists: [],
    communitylists: [],
    routemaps: [],
    qosclassmaps: [],
    qospolicymaps: [],
    multicast: [{}],
    multicastinterfaces: [],
    ipsla: [],
    tracks: [],
    tunnels: []
  };
}

export function getDefaultRouterTab(routerNumber = 1) {
  return getBaseDeviceTab("R", routerNumber, 4300);
}

export function getDefaultSwitchTab(switchNumber = 1) {
  return {
    ...getBaseDeviceTab("S", switchNumber, 2960),
    vlans: [],
    dhcpsnooping: [{ enabled: false, vlans: [], trustedPorts: [], disableOption82: false, ratelimits: [] }],
    switchports: [{
      port: "",
      description: "",
      mode: "access",
      accessvlan: "",
      nativevlan: "",
      allowedvlans: "",
      portfast: false,
      bpduguard: false,
      rootguard: false,
      loopguard: false,
      udld: false,
      stormBroadcastLevel: "",
      stormMulticastLevel: "",
      stormAction: "",
      dhcpSnoopingTrust: false,
      dhcpSnoopingRate: "",
      arpInspectionTrust: false,
      ipSourceGuard: false,
      ipSourceGuardMacCheck: false,
      dot1x: false,
      mab: false,
      authenticationPortControl: "auto",
      hostMode: "single-host",
      voicevlan: "",
      guestvlan: "",
      authViolation: "shutdown",
      shutdown: false
    }],
    portchannels: [],
    stp: [
      {
        mode: "rapid-pvst",
        portfastdefault: false,
        bpduguarddefault: false,
        mstname: "",
        mstrevision: ""
      }
    ],
    stpvlan: [],
    portsecurity: [],
    accessedge: [{
      ipDeviceTracking: false,
      daiVlans: "",
      daiValidateSrcMac: false,
      daiValidateDstMac: false,
      daiValidateIp: true,
      errdisableRecovery: false,
      errdisableRecoveryCauses: "",
      errdisableRecoveryInterval: ""
    }],
    spansessions: []
  };
}

export function getDefaultVlanData() {
  return [
    {
      name: "VLAN1",
      id: ""
    }
  ];
}

export function getDefaultProjectSnapshot() {
  return {
    router_data: [getDefaultRouterTab(1)],
    router_final: Array.from({ length: SNAPSHOT_ARRAY_LENGTH }, () => ({})),
    switch_data: [getDefaultSwitchTab(1)],
    switch_final: Array.from({ length: SNAPSHOT_ARRAY_LENGTH }, () => ({})),
    vlan_data: getDefaultVlanData()
  };
}

function migrateRenamedKeys(obj) {
  if (!obj || typeof obj !== "object") return obj;
  // domæne → domain
  if ("domæne" in obj && !("domain" in obj)) {
    obj.domain = obj.domæne;
  }
  delete obj.domæne;
  // navn → name (for VLANs)
  if ("navn" in obj && !("name" in obj)) {
    obj.name = obj.navn;
  }
  delete obj.navn;
  return obj;
}

function normalizeDeviceData(data, fallbackFactory) {
  const fallback = [fallbackFactory(1)];
  const normalized = Array.isArray(data) ? data : fallback;

  return normalized.map((item, index) => {
    const nextItem = {
      ...fallbackFactory(index + 1),
      ...(item || {})
    };

    // Migrate renamed keys in initial and dhcp sections
    if (Array.isArray(nextItem.initial)) {
      nextItem.initial.forEach(migrateRenamedKeys);
    }
    if (Array.isArray(nextItem.dhcp)) {
      nextItem.dhcp.forEach(migrateRenamedKeys);
    }
    if (Array.isArray(nextItem.vlans)) {
      nextItem.vlans.forEach(migrateRenamedKeys);
    }

    if (!Array.isArray(nextItem.misc)) {
      nextItem.misc = [{}, {}, {}];
    }

    nextItem.misc[0] = nextItem.misc[0] || {};
    nextItem.misc[1] = nextItem.misc[1] || {};
    nextItem.misc[2] = nextItem.misc[2] || {};

    if (!Array.isArray(nextItem.interfaces)) {
      nextItem.interfaces = [{ subinterfaces: [] }];
    }

    if ("switchports" in nextItem && !Array.isArray(nextItem.switchports)) {
      nextItem.switchports = [];
    }

    if ("portchannels" in nextItem && !Array.isArray(nextItem.portchannels)) {
      nextItem.portchannels = [];
    }

    if ("vlans" in nextItem && !Array.isArray(nextItem.vlans)) {
      nextItem.vlans = [];
    }

    if ("dhcpsnooping" in nextItem && !Array.isArray(nextItem.dhcpsnooping)) {
      nextItem.dhcpsnooping = [{ enabled: false, vlans: [], trustedPorts: [], disableOption82: false, ratelimits: [] }];
    }

    if (!Array.isArray(nextItem.v6interfaces)) {
      nextItem.v6interfaces = [{ v6subinterfaces: [] }];
    }

    if (!Array.isArray(nextItem.vrf)) nextItem.vrf = [];
    if (!Array.isArray(nextItem.ntp)) nextItem.ntp = [{}];
    if (!Array.isArray(nextItem.ntpservers)) nextItem.ntpservers = [];
    if (!Array.isArray(nextItem.syslog)) nextItem.syslog = [{}];
    if (!Array.isArray(nextItem.syslogservers)) nextItem.syslogservers = [];
    if (!Array.isArray(nextItem.snmp)) nextItem.snmp = [{}];
    if (!Array.isArray(nextItem.snmpcommunities)) nextItem.snmpcommunities = [];
    if (!Array.isArray(nextItem.snmphosts)) nextItem.snmphosts = [];
    if (!Array.isArray(nextItem.snmpv3groups)) nextItem.snmpv3groups = [];
    if (!Array.isArray(nextItem.snmpv3users)) nextItem.snmpv3users = [];
    if (!Array.isArray(nextItem.snmpv3views)) nextItem.snmpv3views = [];
    if (!Array.isArray(nextItem.ipv4acls)) nextItem.ipv4acls = [];
    if (!Array.isArray(nextItem.ipv6acls)) nextItem.ipv6acls = [];
    if (!Array.isArray(nextItem.prefixlists)) nextItem.prefixlists = [];
    if (!Array.isArray(nextItem.communitylists)) nextItem.communitylists = [];
    if (!Array.isArray(nextItem.routemaps)) nextItem.routemaps = [];
    if (!Array.isArray(nextItem.qosclassmaps)) nextItem.qosclassmaps = [];
    if (!Array.isArray(nextItem.qospolicymaps)) nextItem.qospolicymaps = [];
    if (!Array.isArray(nextItem.multicast)) nextItem.multicast = [{}];
    if (!Array.isArray(nextItem.multicastinterfaces)) nextItem.multicastinterfaces = [];
    if (!Array.isArray(nextItem.ipsla)) nextItem.ipsla = [];
    if (!Array.isArray(nextItem.tracks)) nextItem.tracks = [];
    if (!Array.isArray(nextItem.tunnels)) nextItem.tunnels = [];

    if ("stp" in nextItem && !Array.isArray(nextItem.stp)) {
      nextItem.stp = [{
        mode: "rapid-pvst",
        portfastdefault: false,
        bpduguarddefault: false,
        mstname: "",
        mstrevision: ""
      }];
    }
    if ("stpvlan" in nextItem && !Array.isArray(nextItem.stpvlan)) nextItem.stpvlan = [];
    if ("portsecurity" in nextItem && !Array.isArray(nextItem.portsecurity)) nextItem.portsecurity = [];
    if ("accessedge" in nextItem && !Array.isArray(nextItem.accessedge)) {
      nextItem.accessedge = [{
        ipDeviceTracking: false,
        daiVlans: "",
        daiValidateSrcMac: false,
        daiValidateDstMac: false,
        daiValidateIp: true,
        errdisableRecovery: false,
        errdisableRecoveryCauses: "",
        errdisableRecoveryInterval: ""
      }];
    }
    if ("spansessions" in nextItem && !Array.isArray(nextItem.spansessions)) nextItem.spansessions = [];

    return nextItem;
  });
}

export function normalizeProjectSnapshot(snapshot) {
  const defaults = getDefaultProjectSnapshot();
  const nextSnapshot = {
    ...defaults,
    ...(snapshot || {})
  };

  return {
    ...nextSnapshot,
    router_data: normalizeDeviceData(nextSnapshot.router_data, getDefaultRouterTab),
    router_final: Array.isArray(nextSnapshot.router_final)
      ? nextSnapshot.router_final
      : defaults.router_final,
    switch_data: normalizeDeviceData(nextSnapshot.switch_data, getDefaultSwitchTab),
    switch_final: Array.isArray(nextSnapshot.switch_final)
      ? nextSnapshot.switch_final
      : defaults.switch_final,
    vlan_data: (Array.isArray(nextSnapshot.vlan_data)
      ? nextSnapshot.vlan_data
      : defaults.vlan_data
    ).map(migrateRenamedKeys)
  };
}
